import { all } from 'redux-saga/effects';
import authSaga from 'features/auth/authSaga';
import messageSaga from 'features/message/messageSaga';

export default function* rootSaga() {
  yield all([authSaga(), messageSaga()]);
}
